// Others
import { CONTENT_TYPE_FORM_DATA } from '~/utils/constants/common';
import axiosClient from './axiosClient';
import { urlApiTrailer } from '~/utils/constants/apis';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IBodyUpdate } from '~/utils/interface/common';
import { IFormTrailer, IQueryParamTrailer, ITrailer, ITrailerDetail } from '~/utils/interface/trailer';

const trailerApi = {
  getListTrailer: (params: IQueryParamTrailer) => {
    const url = urlApiTrailer.getListTrailer;
    return axiosClient.get<IBaseResponse<IListDataResponse<ITrailer[]>>>(url, { params });
  },

  getDetailTrailer: (id: string) => {
    const url = urlApiTrailer.getDetailTrailer(id);
    return axiosClient.get<IBaseResponse<ITrailerDetail>>(url);
  },

  createTrailer: (body: IFormTrailer) => {
    const url = urlApiTrailer.createTrailer;
    return axiosClient.post<IBaseResponse>(url, body);
  },

  updateTrailer: (params: IBodyUpdate<IFormTrailer>) => {
    const { id, body } = params;
    const url = urlApiTrailer.updateTrailer(id);
    return axiosClient.put<IBaseResponse>(url, body);
  },

  deleteTrailer: (id: string) => {
    const url = urlApiTrailer.deleteTrailer(id);
    return axiosClient.delete<IBaseResponse>(url);
  },
};

export default trailerApi;
